import _objectSpread from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
// import { define } from "cordova";
// import { define } from "cordova";
import { defineAsyncComponent, onMounted, onUnmounted } from "vue";
import { defineComponent } from "vue";
// var note_player = require('noteplayer');

var version = require("./components/versionNumber.js");
var faqComponent = defineAsyncComponent(function () {
  return import("./components/faqComponent.vue");
});
var MainMenu = defineAsyncComponent(function () {
  return import('./components/MainMenu.vue');
});

// const AppIntro = defineAsyncComponent(() =>
//   import(/* webpackChunkName: "appintro" */  "./components/appIntroImmersive.vue"),
// );

var FloatingImage = defineAsyncComponent(function () {
  return import("./components/chunks/FloatingImage.vue");
});

// const QuickIntro = defineAsyncComponent(() =>
//   import("./components/appIntroQuick.vue"),
// );

var IntroAvatarViewer = defineAsyncComponent(function () {
  return import("./components/intro/IntroAvatarViewer.vue");
});
var AppExpectations = defineAsyncComponent(function () {
  return import("./components/intro/AppExpectations.vue");
});
var UserRegistrationPurple = defineAsyncComponent(function () {
  return import("./components/intro/UserRegistrationPurple.vue");
});
var IntroQuickMessage = defineAsyncComponent(function () {
  return import("./components/intro/IntroQuickMessage.vue");
});
var UserLoginBlue = defineAsyncComponent(function () {
  return import("./components/intro/UserLoginBlue.vue");
});
var CustomerGender = defineAsyncComponent(function () {
  return import("./components/intro/CustomerGender.vue");
});
var IntroGallery = defineAsyncComponent(function () {
  return import("./components/intro/IntroGallery.vue");
});
var BluetoothRingController = defineAsyncComponent(function () {
  return import("./components/BluetoothRingController.vue");
});
var PurchaseTokens = defineAsyncComponent(function () {
  return import("./components/PurchaseTokens.vue");
});
var TokensFalling = defineAsyncComponent(function () {
  return import("./components/payments/TokensFalling.vue");
});
var ShowXRatedConfirmation = defineAsyncComponent(function () {
  return import("./components/intro/showXRatedConfirmation.vue");
});
var IntroVoice = defineAsyncComponent(function () {
  return import("./components/intro/IntroVoice.vue");
});
var IntroSexualHowTo = defineAsyncComponent(function () {
  return import("./components/intro/IntroSexualHowTo.vue");
});
var IntroPersonality = defineAsyncComponent(function () {
  return import("./components/intro/IntroPersonality.vue");
});
var IntroInterests = defineAsyncComponent(function () {
  return import("./components/intro/IntroInterests.vue");
});
var CompanionPreference = defineAsyncComponent(function () {
  return import("./components/intro/CompanionPreference.vue");
});
var DrawingCanvas = defineAsyncComponent(function () {
  return import("./components/DrawingCanvas.vue");
});
var WebsiteComponent = defineAsyncComponent(function () {
  return import("./components/Website.vue");
});
var CameraComponent = defineAsyncComponent(function () {
  return import("./components/CameraComponent.vue");
});
var ExperienceSelector = defineAsyncComponent(function () {
  return import("./components/chunks/ExperienceSelector.vue");
});
var VideoComponent = defineAsyncComponent(function () {
  return import("./components/chunks/VideoComponent.vue");
});
var VoiceController = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "voicecontroller" */"./components/logic/VoiceController.vue");
});
var ActionBar = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "actionbar" */"./components/chunks/ActionBar.vue");
});
var LocationsPermissionsNeeded = defineAsyncComponent(function () {
  return import("./components/chunks/LocationPermissionsNeeded.vue");
});
var AppFeatures = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "appfeatures" */"./components/chunks/AppFeatures.vue");
});
var LeaveReview = defineAsyncComponent(function () {
  return import("./components/chunks/LeaveReview.vue");
});
var DownvoteComponent = defineAsyncComponent(function () {
  return import("./components/chunks/DownvoteComponent.vue");
});
var UpgradeVoices = defineAsyncComponent(function () {
  return import("./components/chunks/UpgradeVoices.vue");
});
var ClothingStore = defineAsyncComponent(function () {
  return import("./components/chunks/ClothingStore.vue");
});
var NewAvatarSelector = defineAsyncComponent(function () {
  return import("./components/chunks/NewAvatarSelector.vue");
});
var HandleAIResponse = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "handleairesponse" */"./components/logic/HandleAIResponse.vue");
});
var ActivityLogs = defineAsyncComponent(function () {
  return import("./components/chunks/ActivityLogs.vue");
});
var ImageUploadComponent = defineAsyncComponent(function () {
  return import("./components/ImageUploadComponent.vue");
});
var WalkthroughComponent = defineAsyncComponent(function () {
  return import("./components/WalkthroughComponent.vue");
});
var InstallPWA = defineAsyncComponent(function () {
  return import("./components/InstallPWA.vue");
});
var CameraPermissionsNeeded = defineAsyncComponent(function () {
  return import("./components/chunks/CameraPermissionsNeeded.vue");
});
var UpgradeMembership = defineAsyncComponent(function () {
  return import("./components/UpgradeMembership.vue");
});
var NewLogin = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "newlogin" */"./components/NewLogin.vue");
});
var LoaderComponent = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "loadercomponent" */"./components/LoaderComponent.vue");
});
var AssistantTools = defineAsyncComponent(function () {
  return import("./components/AssistantTools.vue");
});
var CallsComponent = defineAsyncComponent(function () {
  return import("./components/CallsComponent.vue");
});
var BarChart = defineAsyncComponent(function () {
  return import("./components/BarChart.vue");
});
var MapComponent = defineAsyncComponent(function () {
  return import("./components/MapComponent.vue");
});
var TopActionBar = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "topactionbar" */"./components/TopActionBar.vue");
});
var Pageloader = defineAsyncComponent(function () {
  return import("./components/PageLoader.vue");
});
var todoComponent = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "todo" */"./components/todoComponent.vue");
});
var notesComponent = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "notes" */"./components/notesComponent.vue");
});
var MainApplication = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "mainapplication" */"./views/MainApplication.vue");
});
var PermissionsComponent = defineAsyncComponent(function () {
  return import( /* webpackChunkName: "permissions" */"./components/PermissionsComponent.vue");
});
var BottomBar = defineAsyncComponent(function () {
  return import("./components/BottomBar.vue");
});
export default defineComponent({
  name: "App",
  components: {
    AssistantTools: AssistantTools,
    faqComponent: faqComponent,
    AppExpectations: AppExpectations,
    UserRegistrationPurple: UserRegistrationPurple,
    IntroQuickMessage: IntroQuickMessage,
    UserLoginBlue: UserLoginBlue,
    CustomerGender: CustomerGender,
    IntroGallery: IntroGallery,
    IntroAvatarViewer: IntroAvatarViewer,
    ShowXRatedConfirmation: ShowXRatedConfirmation,
    PurchaseTokens: PurchaseTokens,
    TokensFalling: TokensFalling,
    BluetoothRingController: BluetoothRingController,
    IntroVoice: IntroVoice,
    IntroSexualHowTo: IntroSexualHowTo,
    IntroPersonality: IntroPersonality,
    IntroInterests: IntroInterests,
    FloatingImage: FloatingImage,
    CompanionPreference: CompanionPreference,
    MainMenu: MainMenu,
    CameraComponent: CameraComponent,
    WebsiteComponent: WebsiteComponent,
    ImageUploadComponent: ImageUploadComponent,
    VideoComponent: VideoComponent,
    ExperienceSelector: ExperienceSelector,
    VoiceController: VoiceController,
    HandleAIResponse: HandleAIResponse,
    LeaveReview: LeaveReview,
    DownvoteComponent: DownvoteComponent,
    UpgradeVoices: UpgradeVoices,
    ClothingStore: ClothingStore,
    NewAvatarSelector: NewAvatarSelector,
    ActivityLogs: ActivityLogs,
    ActionBar: ActionBar,
    LocationsPermissionsNeeded: LocationsPermissionsNeeded,
    AppFeatures: AppFeatures,
    InstallPWA: InstallPWA,
    CameraPermissionsNeeded: CameraPermissionsNeeded,
    NewLogin: NewLogin,
    WalkthroughComponent: WalkthroughComponent,
    MainApplication: MainApplication,
    Pageloader: Pageloader,
    PermissionsComponent: PermissionsComponent,
    LoaderComponent: LoaderComponent,
    BarChart: BarChart,
    MapComponent: MapComponent,
    todoComponent: todoComponent,
    UpgradeMembership: UpgradeMembership,
    BottomBar: BottomBar,
    TopActionBar: TopActionBar,
    CallsComponent: CallsComponent,
    notesComponent: notesComponent,
    DrawingCanvas: DrawingCanvas
  },
  beforeMount: function beforeMount() {},
  // add computed property for logLeft
  setup: function setup() {
    var wakeLock = null;
    function requestWakeLock() {
      return _requestWakeLock.apply(this, arguments);
    }
    function _requestWakeLock() {
      _requestWakeLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if ("wakeLock" in navigator) {
                _context2.next = 3;
                break;
              }
              console.log("Wake Lock API not supported in this browser");
              // this.$store.commit("updateActivityLogs", "wakelock not supported");
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return navigator.wakeLock.request("screen");
            case 6:
              wakeLock = _context2.sent;
              wakeLock.addEventListener("release", function () {
                console.log("Wake Lock released");
              });
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              console.log("Failed to acquire wake lock: ".concat(_context2.t0.name, ", ").concat(_context2.t0.message));
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 10]]);
      }));
      return _requestWakeLock.apply(this, arguments);
    }
    function releaseWakeLock() {
      return _releaseWakeLock.apply(this, arguments);
    }
    function _releaseWakeLock() {
      _releaseWakeLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(wakeLock !== null)) {
                _context3.next = 4;
                break;
              }
              _context3.next = 3;
              return wakeLock.release();
            case 3:
              wakeLock = null;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _releaseWakeLock.apply(this, arguments);
    }
    var handleVisibilityChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(wakeLock && document.visibilityState === "visible")) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return requestWakeLock();
            case 3:
              _context.next = 8;
              break;
            case 5:
              if (!(wakeLock && document.visibilityState === "hidden")) {
                _context.next = 8;
                break;
              }
              _context.next = 8;
              return releaseWakeLock();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleVisibilityChange() {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(function () {
      requestWakeLock();
      document.addEventListener("visibilitychange", handleVisibilityChange); //aivitar.com
    });
    onUnmounted(function () {
      try {
        releaseWakeLock();
      } catch (error) {
        console.log(error);
      }
      try {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      } catch (error) {
        console.log(error);
      }
    });
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var service, itemDetails, subscriptionDetails, localChange, url, access_token;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _this.stopWebAbuse();
            _this.$store.dispatch("checkForPro");
            window.clearConsole = setInterval(function () {}, 500);
            // clear the console on load
            // console.clear();

            _this.$store.dispatch('reportEvent', 'app_loaded');
            _this.checkForRedirects();
            // await note_player.buildFromName('A4').play();
            // setTimeout(async ()=>{
            //   await note_player.buildFromName('C3').play();
            // },100);

            // setTimeout(async ()=>{
            //   await note_player.buildFromName('B4').play();
            // },500);

            // setTimeout(async ()=>{
            //   await note_player.buildFromName('E5').play();
            // },1000);

            // setTimeout(async ()=>{
            //   await note_player.buildFromName('C6').play();
            // },1500);

            // update to latest app version
            // this.$store.dispatch("refreshAppIfChanged");

            // const locationPermission = localStorage.getItem('permission_location');
            _this.$store.dispatch("checkDailyLimit");
            if (_this.$store.state.permission_location == true || _this.$store.state.permission_location == "true") {
              _this.$store.dispatch("requestLocationPermission");
            } else {
              console.log("no location permissions:", _this.$store.state.permission_location);
            }
            _this.$store.dispatch("getAndroidDeviceID");
            _this.$store.dispatch("checkAIVitarX");
            if (localStorage.getItem("security")) {
              _this.checkProfileComplete();
            }
            _this.checkExistingGooglePurchases();
            _this.$store.dispatch("checkAllHistoricalGooglePurchases");

            // X build number
            _this.updateBuildNumber();

            // NO - Token
            if (!localStorage.getItem("security")) {
              _this.showLogin = true;
              _this.$store.commit("updateShowUserLogin", true);
            } else {
              _this.$store.commit("updateLoginDetected", true);
              // this.handleLoginDetected();
            }
            if (!(process.env.VUE_APP_ANDROID === "true")) {
              _context4.next = 53;
              break;
            }
            if (!("getDigitalGoodsService" in window)) {
              _context4.next = 51;
              break;
            }
            _this.playBillingActive = true;
            console.log("Digital Goods API is supported");
            // Get the service
            _context4.prev = 18;
            _context4.next = 21;
            return window.getDigitalGoodsService("https://play.google.com/billing");
          case 21:
            service = _context4.sent;
            _this.playBillingDetails.serviceAvailable = true;
            _context4.next = 28;
            break;
          case 25:
            _context4.prev = 25;
            _context4.t0 = _context4["catch"](18);
            _this.playBillingDetails.serviceError = _context4.t0;
          case 28:
            if (!service) {
              _context4.next = 49;
              break;
            }
            _context4.prev = 29;
            _context4.next = 32;
            return service.getDetails(["clothing"]);
          case 32:
            itemDetails = _context4.sent;
            _this.playBillingDetails.itemsDetails = itemDetails;
            // for (const item of itemDetails) {
            //   // Display item information to user
            //   displayItem(item.title, item.description, item.price);
            // }
            _context4.next = 39;
            break;
          case 36:
            _context4.prev = 36;
            _context4.t1 = _context4["catch"](29);
            _this.playBillingDetails.getDetailsError = _context4.t1;
          case 39:
            _context4.prev = 39;
            _context4.next = 42;
            return service.getDetails(["clothing"]);
          case 42:
            subscriptionDetails = _context4.sent;
            _this.playBillingDetails.subscriptionItems = JSON.stringify(subscriptionDetails);
            // for (const item of itemDetails) {
            //   // Display item information to user
            //   displayItem(item.title, item.description, item.price);
            // }
            _context4.next = 49;
            break;
          case 46:
            _context4.prev = 46;
            _context4.t2 = _context4["catch"](39);
            _this.playBillingDetails.subscriptionItems = _context4.t2;
          case 49:
            _context4.next = 53;
            break;
          case 51:
            console.log("Digital Goods API is not supported");
            _this.playBillingDetails.serviceAvailable = false;
          case 53:
            // if (process.env.NODE_ENV === 'development' && localStorage.getItem('security') === null) {
            //   localStorage.setItem('security', 'U2FsdGVkX190soXdFwQl26TkmqBdzfHcw30rQ3DkdYJV+6gTXef0/s+bEOoWQgm3jWXHW5blwVpzQJscVb6pbOSiBMbg+CB6ulFgwFOtJJrZTE8dHCLE/81PAM51wQ8f9E39jgY/YwhkcxHq6JqXoLziaVe2GpiDY1EK3CWxldltoqx0VZW87NpKScUqSbZlgxvoeleAFDP8QtqlinOM01Vy28Botg2bozddyplP2NdL8xY+7tF67TmL4piuwkffGOR3NxvsbsRWu3Cac0aLQXEmetD9XRTwZ2BgJ77R3R2HEYogDKrWbwk/KKq6rrzg59QowxJ8ESpdzANAzIZLreClwbwqlb65t2YSOjEpmZvBU1fbQhqFrz/Ds7LqSAbrHuwdPQVDB0m2aFUu0mHBtLMxLy+JOu8SbPVYNA3H4baOhIjXl+Nv5LmSwFCRfXBxfL1XREFXVRrsYsv/TTiST5maPCL291X+0byXar/x6UcduMZMkrMdawmQ5KozLkVp+ZzxxWD8ZdSHVt/+ngkBzExat/1eEhmpcpjkte65s9UfTOI1+CE8rZCLmuUESyTC');
            // }
            localChange = localStorage.getItem("change");
            if (localChange === "boom") {
              localStorage.removeItem("change");
              if (_this.$store.state.showMainApplication === true || _this.$store.state.showMainApplication === 'true') {
                window.location.reload();
              }
            }
            if (!localChange) {
              localStorage.setItem("change", "boom");
            }
            if ("serviceWorker" in navigator) {
              navigator.serviceWorker.addEventListener("controllerchange", function () {
                // Reload the page when the new service worker takes control
                if (_this.$store.state.showMainApplication === true || _this.$store.state.showMainApplication === 'true') {
                  window.location.reload();
                }
              });
            }
            console.log("App mounted");
            localStorage.setItem("spoken", "false");

            //determine if
            // const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            // setTimeout(() => {
            //   const synth = window.speechSynthesis;
            //   let voices = synth.getVoices();

            //   //remove eloquence voices from list since they break the app
            //   voices = voices.filter(
            //     (voice) =>
            //       !voice.voiceURI.includes("eloquence") && !voice.voiceURI.includes("Bubbles"),
            //   );

            //   let selectedVoice = null;

            //   selectedVoice = voices.filter(
            //     (voice) => voice.name.toLowerCase().trim() == "karen",
            //   )[0];

            //   if (!selectedVoice) {
            //     // get voice for Tessa en-GB from voices
            //     selectedVoice = voices.filter((voice) => voice.name === "tessa")[0];
            //   }

            //   if (!selectedVoice) {
            //     // get voice for Tessa en-GB from voices
            //     selectedVoice = voices.filter(
            //       (voice) => voice.name === "Google UK English Female",
            //     )[0];
            //   }

            //   if (selectedVoice) {
            //     this.$store.commit("updateSelectedAvatarVoice", selectedVoice);
            //     this.$store.commit(
            //       "updateSelectedAvatarLanguage",
            //       selectedVoice.lang.split("-")[0] + "-",
            //     );
            //     // this.$store.commit('updateSelectedAvatarLanguage', 'en-');
            //   }
            // }, 2000);

            // we we have no security localStorage then don't show popup
            // if (!localStorage.getItem('security')) {
            //   this.showInstallPrompt = false;
            //   this.$state.commit('updateShowMarketingView', true);
            // } else {
            //   this.showInstallPrompt = true;
            // }

            // let localDevelopment = localStorage.getItem('localdevelopment')
            // if (!localStorage.getItem('security') && !localDevelopment) {
            // }

            if (window.location.href.indexOf("/alexaAuth") > -1) {
              // grab access_token form url and store it in localstorage
              url = window.location.href;
              access_token = url.split("access_token=")[1].split("&")[0]; // let token_type = url.split('token_type=')[1].split('&')[0];
              // let scope = url.split('scope=')[1];
              localStorage.setItem("access_token", access_token);
            }
            if (process.env.NODE_ENV === "development") {
              localStorage.setItem("localdevelopment", "true");
            }
            // turn map on so that it renders and then turn it off and keep it on in background
            // this.$store.commit('updateShowMap', true);
            // setTimeout(() => {
            //   this.$store.commit('updateShowMap', false);
            // }, 1000);

            // Check if the PWA is currently installed
            if (window.matchMedia("(display-mode: standalone)").matches) {
              // The PWA is installed
              _this.$store.commit("updateAppIsInstalled", true);
            } else {
              // The PWA is not installed
              _this.$store.commit("updateAppIsInstalled", false);
            }
            // wait for document to load then showWalkthrough = true to show walkthrough
            setTimeout(function () {
              _this.showWalkthrough = true;
            }, 4000);
            if (window.location.href.indexOf("/passwordReset") > -1) {
              // if so, show password reset page
              _this.$store.state.showPasswordReset = true;
              _this.$store.commit("updateShowPasswordReset", true);
            }
            if (window.matchMedia("(display-mode: browser)").matches) {
              _this.displayMode = "browser";
            }
            if (window.matchMedia("(display-mode: fullscreen)").matches) {
              _this.displayMode = "fullscreen";
              _this.showApplication = true;
            }
            if (window.matchMedia("(display-mode: standalone)").matches) {
              _this.displayMode = "standalone";
              _this.showApplication = true;
            }
          case 67:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[18, 25], [29, 36], [39, 46]]);
    }))();
  },
  created: function created() {
    var _this2 = this;
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", function () {
        _this2.prompt = true;
      });
    }
  },
  watch: {
    "browser": "handleBrowserSpecifics",
    "$store.state.appType": "detectBrowser",
    "$store.state.newUserDetected": "handleNewUserDetected",
    "$store.state.loginDetected": "handleLoginDetected",
    // preload avatar images and store to cache when main application is triggered
    "$store.state.showMainApplication": function $storeStateShowMainApplication() {
      if (this.$store.state.showMainApplication) {
        if (process.env.NODE_ENV !== "development") {
          navigator.serviceWorker.ready.then(function (registration) {
            registration.active.postMessage({
              type: "trigger-install"
            });
          });
        } else {
          console.log("prevent service worker locally in dev");
        }
      }
    }
  },
  methods: {
    handleBrowserSpecifics: function handleBrowserSpecifics() {
      if (this.browser != 'Chrome') {
        this.notsupportedbrowser = true;
        this.showMainApplication = false;
        this.$store.commit('updateShowMainApplication', false);
        this.$store.commit('updateShowUpgradeMembershipPage', false);
      }
    },
    stopWebAbuse: function stopWebAbuse() {
      // if development return
      if (process.env.NODE_ENV === 'development') {
        return;
      }
      // check if developer tools is opened and prevent it

      var element = new Image();
      Object.defineProperty(element, 'id', {
        get: function get() {
          // window.location.href = 'about:blank'; // Redirect to a blank page
          // redirect page
          Window.location.href = 'https://www.google.com';
          return 'blocked';
        }
      });
      document.addEventListener('contextmenu', function (event) {
        return event.preventDefault();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'F12' || event.ctrlKey && event.shiftKey && event.key === 'I' || event.ctrlKey && event.shiftKey && event.key === 'J' || event.ctrlKey && event.key === 'U') {
          event.preventDefault();
        }
      });

      //     const element = new Image();
      // Object.defineProperty(element, 'id', {
      //   get: function () {
      //     window.location.href = 'about:blank';
      //   }
      // });
      setInterval(function () {
        // console.log(element);
        // console.clear();
      }, 500);
    },
    detectBrowser: function detectBrowser() {
      // We don't want to do this on the app version, only the web
      if (this.$store.state.appType != 'Web') {
        return;
      }
      var userAgent = navigator.userAgent;
      if (/MSIE|Trident/.test(userAgent)) {
        this.browser = 'Internet Explorer';
      } else if (/Edg/.test(userAgent)) {
        this.browser = 'Edge';
      } else if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
        this.browser = 'Chrome';
      } else if (userAgent.indexOf('Chrome') > -1) {
        this.browser = 'Chrome';
      } else if (/CriOS/.test(userAgent)) {
        this.browser = 'Chrome';
      } else if (/Android/.test(userAgent) && /Chrome/.test(userAgent)) {
        this.browser = 'Chrome';
      } else if (/Firefox/.test(userAgent)) {
        this.browser = 'Firefox';
      } else if (/Safari/.test(userAgent) && /Apple Computer/.test(navigator.vendor)) {
        this.browser = 'Safari';
      } else if (/OPR/.test(userAgent)) {
        this.browser = 'Opera';
      } else if (/SamsungBrowser/.test(userAgent)) {
        this.browser = 'Samsung Internet';
      } else {
        this.browser = 'Other';
      }
    },
    updateMetadata: function updateMetadata(url, title, description, keywords) {
      function updateMetaTagSpecial(attributeName, attributeValue, content) {
        var metaTag = document.querySelector("meta[".concat(attributeName, "=\"").concat(attributeValue, "\"]"));
        if (metaTag) {
          metaTag.setAttribute('content', content);
        } else {
          metaTag = document.createElement('meta');
          metaTag.setAttribute(attributeName, attributeValue);
          metaTag.setAttribute('content', content);
          document.head.appendChild(metaTag);
        }
      }
      document.title = title;
      // Update meta tags
      var descriptionMeta = document.querySelector('meta[name="description"]');
      if (descriptionMeta) {
        descriptionMeta.setAttribute('content', description);
      }
      var keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (keywordsMeta) {
        if (Array.isArray(keywords)) {
          keywordsMeta.setAttribute('content', keywords.join(', '));
        } else {
          keywordsMeta.setAttribute('content', keywords);
        }
      }
      updateMetaTagSpecial('name', 'twitter:title', title);
      updateMetaTagSpecial('name', 'twitter:description', description);
      // updateMetaTagSpecial('name', 'twitter:image', newImage);

      // Update Open Graph meta tags
      updateMetaTagSpecial('property', 'og:title', title);
      updateMetaTagSpecial('property', 'og:description', description);
      // updateMetaTagSpecial('property', 'og:image', newImage);
      updateMetaTagSpecial('property', 'og:url', url);
    },
    checkForRedirects: function checkForRedirects() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var url, generatedArticles, article, callback, marketing_id, params, referrer, _marketing_id, _params;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              url = window.location.href; // if(url.toLowerCase().indexOf('2879') > 0){
              //   this.$store.commit('updateShowWebsite', false);
              //   this.$store.commit("updateShowRegistration", true);
              // } else
              // get entire url string including parameters
              // let url = window.location.href;
              // get subscription value
              if (!(window.location.href.indexOf('/articles/') > -1)) {
                _context5.next = 16;
                break;
              }
              console.log('article link!');
              generatedArticles = require('../public/assets/articles/articles.js');
              console.log('trying to get article:', generatedArticles);
              // since generatedArticles is array with json and key url_slug, see if the url slugs match and then get the article use contains like indexof
              article = generatedArticles.filter(function (article) {
                return url.indexOf(article.url_slug) > -1;
              });
              if (!article || article.length == 0) {
                _this3.showRedirectPage = false;

                // set the metadata
                _this3.updateMetadata(window.location.href, 'Articles List | Browse A.I. Related Articles', 'Come read through some of the most compelling articles related to a.i. and digital companionship', 'ai articles, ai companions, ai girlfriend documentation');
                _this3.$store.commit('updateShowWebsite', true);
                _this3.$store.commit('updateWebsitePage', 'articleList');
              }
              _this3.showRedirectPage = false;
              console.log('article:', article[0]);

              // set the metadata
              _this3.updateMetadata(window.location.href, article[0].title, article[0].meta_description, article[0].meta_keywords);
              _this3.$store.commit('updateShowWebsite', true);
              // set the article to use 
              _this3.$store.commit('updateArticle', article[0]);
              // this.$store.commit('setAppType', 'Web');

              _this3.$store.commit('updateWebsitePage', 'article');
              _context5.next = 119;
              break;
            case 16:
              if (!(window.location.href.indexOf('/articles') > -1)) {
                _context5.next = 23;
                break;
              }
              _this3.showRedirectPage = false;

              // set the metadata
              _this3.updateMetadata(window.location.href, 'Articles List | Browse A.I. Related Articles', 'Come read through some of the most compelling articles related to a.i. and digital companionship', 'ai articles, ai companions, ai girlfriend documentation');
              _this3.$store.commit('updateShowWebsite', true);
              _this3.$store.commit('updateWebsitePage', 'articleList');
              _context5.next = 119;
              break;
            case 23:
              if (!(window.location.href.indexOf('?subscription=') > -1)) {
                _context5.next = 32;
                break;
              }
              if (url.indexOf('successful_payment') > -1) {
                _this3.$store.commit('updateProMembership', true);
                try {
                  callback = function callback() {
                    console.log('Event sent successfully');
                  };
                  window.gtag('event', 'conversion_event_purchase', {
                    'event_callback': callback,
                    'event_timeout': 2000
                    // Add any additional event parameters here
                  });
                } catch (error) {
                  console.log('error sending event:', error);
                }
              }
              _this3.$store.commit('setAppType', 'Web');
              _this3.updateMetadata(window.location.href, 'AIVitar Web App - The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', 'We have built the worlds most advanced a.i. digital companions. The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', null);
              _this3.$store.commit('updateShowWebsite', false);
              _this3.showRedirectPage = false;
              return _context5.abrupt("return");
            case 32:
              if (!(url.toLowerCase().indexOf('hornyaigirl.com') > 0)) {
                _context5.next = 42;
                break;
              }
              localStorage.setItem('referrer', 'hornyaigirl.com');
              marketing_id = Math.floor(Math.random() * 1000000000000000000); // now add random letters and numbers
              marketing_id = marketing_id + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
              // base64 encode the marketing id
              localStorage.setItem('aivitar_id', marketing_id);
              // store marketing_id as cookie 
              // Window.document.cookie = `aivitar_id=${marketing_id}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
              params = new URLSearchParams({
                marketing_id: marketing_id,
                site_ref: 'hornyaigirl.com'
              }).toString(); // redirect to serverless function now with marketing_id and referrer in query parameters
              window.location.href = "https://us-central1-ai-voice-chat-358705.cloudfunctions.net/marketingLink?".concat(params);
              return _context5.abrupt("return");
            case 42:
              if (!(url.toLowerCase().indexOf('ref=') > 0)) {
                _context5.next = 53;
                break;
              }
              // extract the referrer
              referrer = url.split('?ref=')[1];
              localStorage.setItem('referrer', referrer);
              // generate a new random marketing id key for the user
              _marketing_id = Math.floor(Math.random() * 1000000000000000000); // now add random letters and numbers
              _marketing_id = _marketing_id + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
              // base64 encode the marketing id
              localStorage.setItem('aivitar_id', _marketing_id);
              // store marketing_id as cookie 
              // Window.document.cookie = `aivitar_id=${marketing_id}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
              _params = new URLSearchParams({
                marketing_id: _marketing_id,
                site_ref: referrer
              }).toString(); // redirect to serverless function now with marketing_id and referrer in query parameters
              window.location.href = "https://us-central1-ai-voice-chat-358705.cloudfunctions.net/marketingLink?".concat(_params);
              return _context5.abrupt("return");
            case 53:
              _this3.showRedirectPage = false;
              if (!(url.toLowerCase().indexOf('locallytesting') > 0)) {
                _context5.next = 60;
                break;
              }
              // this.$store.commit('setAppType', 'Web');
              _this3.updateMetadata(window.location.href, 'AIVitar Web App - The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', 'We have built the worlds most advanced a.i. digital companions. The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', null);
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', false);
              return _context5.abrupt("return");
            case 60:
              if (!(url.toLowerCase().indexOf('features') > 0)) {
                _context5.next = 66;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', true);
              _this3.$store.commit('updateWebsitePage', 'features');
              _this3.updateMetadata(window.location.href, 'AIVitar - Features', 'Checkout the features we impactfully deliver to our users avatars.', ['aivitar']);
              _context5.next = 119;
              break;
            case 66:
              if (!(url.toLowerCase().indexOf('contact') > 0)) {
                _context5.next = 72;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', true);
              _this3.$store.commit('updateWebsitePage', 'contact');
              _this3.updateMetadata(window.location.href, 'AIVitar - Contact Us', 'Contact AIVitar for any support needs you may have!', ['aivitar']);
              _context5.next = 119;
              break;
            case 72:
              if (!(url.toLowerCase().indexOf('pricing') > 0)) {
                _context5.next = 78;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', true);
              _this3.$store.commit('updateWebsitePage', 'pricing');
              _this3.updateMetadata(window.location.href, 'AIVitar - Pricing', 'AIVitar is free to get you started with some interactions on us. Upgrading provides a robust set of additional benefits for you though. Checkout our pricing...', ['aivitar']);
              _context5.next = 119;
              break;
            case 78:
              if (!(url.toLowerCase().indexOf('terms') > 0)) {
                _context5.next = 84;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', true);
              _this3.$store.commit('updateWebsitePage', 'terms');
              _this3.updateMetadata(window.location.href, 'Terms of Service', 'View the terms of service using the AIVitar App', ['aivitar', 'terms', 'service', 'terms of service']);
              _context5.next = 119;
              break;
            case 84:
              if (!(url.toLowerCase().indexOf('delete') > 0)) {
                _context5.next = 90;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', true);
              _this3.$store.commit('updateWebsitePage', 'deleteaccount');
              _this3.updateMetadata(window.location.href, 'Delete Your Account', 'Request Account Deletion', ['aivitar', 'delete', 'how to delete your account', 'delete account']);
              _context5.next = 119;
              break;
            case 90:
              if (!(url.toLowerCase().indexOf('privacy') > 0)) {
                _context5.next = 96;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', true);
              _this3.$store.commit('updateWebsitePage', 'privacy');
              _this3.updateMetadata(window.location.href, 'Privacy Policy', 'View AIVitar\'s privacy policy. Your privacy is important to us.', ['aivitar', 'privacy', 'policy', 'privacy policy']);
              _context5.next = 119;
              break;
            case 96:
              if (!(url.toLowerCase().indexOf('//aivitar.com') > 0)) {
                _context5.next = 101;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', true);
              _this3.updateMetadata(window.location.href, 'AIVitar - The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', 'We have built the worlds most advanced a.i. digital companions. The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', null);
              _context5.next = 119;
              break;
            case 101:
              if (!(url.toLowerCase().indexOf('//dev.aivitar.com') > 0)) {
                _context5.next = 105;
                break;
              }
              // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', false);
              _context5.next = 119;
              break;
            case 105:
              if (!(url.toLowerCase().indexOf('//app.aivitar.com') > 0 || window.location.href.indexOf('?subscription=') > -1)) {
                _context5.next = 112;
                break;
              }
              _this3.$store.commit('setAppType', 'Web');
              _this3.updateMetadata(window.location.href, 'AIVitar Web App - The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', 'We have built the worlds most advanced a.i. digital companions. The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', null);

              // get entire url string including parameters
              // let url = window.location.href;
              // get subscription value

              if (window.location.href.indexOf('?subscription=successful_payment') > -1) {
                _this3.$store.commit('updateProMembership', true);
              } // window.location.href = 'https://www.aivitar.com';
              _this3.$store.commit('updateShowWebsite', false);
              _context5.next = 119;
              break;
            case 112:
              if (!(url.toLowerCase().indexOf('solutionsidekick') > 0)) {
                _context5.next = 117;
                break;
              }
              _this3.$store.commit('updateShowWebsite', true);
              // redirect to https://aivitar.com
              // window.location.href = 'https://www.aivitar.com';
              return _context5.abrupt("return");
            case 117:
              _this3.$store.commit('updateShowWebsite', true);
              //  this.updateMetadata(window.location.href, 'AIVitar | Homepage', 'We are building NextGen AI Experiences. Digital AI Companions, helpful assistants and more. Come meet the favorite person that you did not know you needed.', ['aivitar', 'homepage']);
              _this3.updateMetadata(window.location.href, 'AIVitar - The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', 'We have built the worlds most advanced a.i. digital companions. The Worlds Leading A.I. Digital Companions, AI Girlfriends, AI Boyfriends capable of having 18+ NSFW conversations with you', null);
            case 119:
              _context5.next = 124;
              break;
            case 121:
              _context5.prev = 121;
              _context5.t0 = _context5["catch"](0);
              console.log("no device_id found");
            case 124:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 121]]);
      }))();
    },
    removePhoto: function removePhoto() {
      this.$store.commit("updatePhoto", null);
      this.currentPosition = _objectSpread({}, this.originalPosition);
    },
    checkProfileComplete: function checkProfileComplete() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var axios, data, config, response, galleryAvatar, i, _galleryAvatar, _i;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (localStorage.getItem("security")) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              axios = require("axios");
              data = {
                token: localStorage.getItem("security"),
                stage: "checkProfileComplete",
                billingPlatform: _this4.$store.state.billingPlatform
              };
              config = {
                method: "post",
                url: "".concat(_this4.$store.state.systemRoute, "/profile"),
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                data: data
              };
              _context6.next = 7;
              return axios(config);
            case 7:
              response = _context6.sent;
              console.log("app.vue profile response", response);
              if (!(response && response.data)) {
                _context6.next = 59;
                break;
              }
              if (response.data.tester === true) {
                _this4.$store.commit('updateTestingAccount', true);
              }
              if (response.data.unlimited === true) {
                _this4.$store.commit('updateProMembership', true);
              }
              if (response.data.uid) {
                console.log('we have UID');
                _this4.$store.commit("updateUserUID", response.data.uid);
              }
              if (response.data.customer_gender) {
                console.log('<<<< we have customer');
                _this4.$store.commit("updateCustomerGender", response.data.customer_gender);
              }
              if (response.data.selected_gender) {
                console.log('<<<< we have avatar gender');
                _this4.$store.commit("updateCompanionPreference", response.data.selected_gender);
              }
              if (response.data.selected_personality) {
                console.log('<<<< we have personality');
                _this4.$store.commit("updateCustomerSelectedProfile", response.data.selected_personality);
              }
              if (response.data.selected_voice) {
                console.log('<<<< we have avatar voice');
                _this4.$store.commit("updateCustomerSelectedVoice", response.data.selected_voice);
                _this4.$store.commit("updateShowMainApplication", true);
              } else {
                console.log('<<<< we have no avatar voice');
                _this4.$store.commit('updatePreventIntroExperience', true);
                // this.$store.commit('stopIntroPage', 'QuickMessage');
                _this4.$store.commit('startIntroPage', 'QuickMessage');
              }
              if (!(response.data.valid === false)) {
                _context6.next = 23;
                break;
              }
              console.log('<<<< we have no valid response');
              localStorage.removeItem("security");
              localStorage.clear();
              // reload page
              location.reload();
              return _context6.abrupt("return");
            case 23:
              if (response.data.selected_gender) {
                _this4.$store.commit("updateCompanionPreference", response.data.selected_gender);
              }
              _this4.$store.commit("updateAppExpectations", {
                romantic: response.data.romantic || false,
                tool: response.data.tool || false,
                assistant: response.data.assistant || false,
                code: response.data.code || false,
                information: response.data.information || false
              });

              /* profile is not completed */
              if (!(response.data.profileCompleted === false)) {
                _context6.next = 42;
                break;
              }
              setTimeout(function () {
                _this4.$store.commit("updateShowMainEntryLoader", false);
              }, 1500);

              // we have an avatar already so set it
              if (!response.data.avatar) {
                _context6.next = 39;
                break;
              }
              console.log("setting avatar");
              _this4.$store.commit("updateAvatar", response.data.avatar);
              i = 0;
            case 31:
              if (!(i < _this4.$store.state.avatarList.length)) {
                _context6.next = 38;
                break;
              }
              if (!(_this4.$store.state.avatarList[i].name.toLowerCase() === response.data.avatar.toLowerCase())) {
                _context6.next = 35;
                break;
              }
              galleryAvatar = _this4.$store.state.avatarList[i];
              return _context6.abrupt("break", 38);
            case 35:
              i++;
              _context6.next = 31;
              break;
            case 38:
              if (galleryAvatar) {
                _this4.$store.commit('updateSelectedGalleryAvatar', galleryAvatar);
              }
            case 39:
              _this4.$store.commit("updateProfileStep", response.data.stepsCompleted);

              //  this.$store.commit('updateProfileStep', 2);
              // this.$store.commit('updateProfileStep', 6);
              // this.showProfileButton = true;
              // this.processProfileStep();
              _context6.next = 57;
              break;
            case 42:
              setTimeout(function () {
                _this4.$store.commit("updateShowMainEntryLoader", false);
              }, 1500);
              // profile is completed
              if (!response.data.avatar) {
                _context6.next = 55;
                break;
              }
              console.log("setting avatar");
              _this4.$store.commit("updateAvatar", response.data.avatar);
              _i = 0;
            case 47:
              if (!(_i < _this4.$store.state.avatarList.length)) {
                _context6.next = 54;
                break;
              }
              if (!(_this4.$store.state.avatarList[_i].name.toLowerCase() === response.data.avatar.toLowerCase())) {
                _context6.next = 51;
                break;
              }
              _galleryAvatar = _this4.$store.state.avatarList[_i];
              return _context6.abrupt("break", 54);
            case 51:
              _i++;
              _context6.next = 47;
              break;
            case 54:
              if (_galleryAvatar) {
                _this4.$store.commit('updateSelectedGalleryAvatar', _galleryAvatar);
              }
            case 55:
              _this4.$store.commit("updateProfileCompleted", true);
              _this4.$store.commit("updateProfileCompletedAlmost", true);
            case 57:
              _context6.next = 60;
              break;
            case 59:
              setTimeout(function () {
                _this4.$store.commit("updateShowMainEntryLoader", false);
              }, 1500);
            case 60:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    checkExistingGooglePurchases: function checkExistingGooglePurchases() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (process.env.VUE_APP_ENVIRONMENT === "development" || "getDigitalGoodsService" in window) {
                console.log("check existing google purchases");
                _this5.$store.dispatch("validateGooglePayment", true);
                // var digitalGoodsService = await window.getDigitalGoodsService("https://play.google.com/billing");
                // var purchases = await digitalGoodsService.listPurchases();
                // this.$store.commit('updateBillingCurrentItems', purchases);
                // this.validateGoogleSubscriptions(purchases);

                // for (var p of purchases) {
                //   VerifyOnBackendAndGrantEntitlement(p.itemId, p.purchaseToken);
                // }
              }
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handleLoginDetected: function handleLoginDetected() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (_this6.$store.state.loginDetected === true) {
                _this6.showLogin = false;
                _this6.$store.commit("updateShowMainApplication", true);
                _this6.$store.commit("updateLoginDetected", false);
              }
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // after user registers a new account
    handleNewUserDetected: function handleNewUserDetected() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (_this7.$store.state.newUserDetected === true) {
                _this7.$store.commit("updateNewUserDetected", false);
                _this7.showLogin = false;
              }
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    // async updateNewUserDetected(){
    //   if(this.$store.state.billingPlatform ==='android'){
    //     this.showGoogleSubscriptionPaymentOptions = true;
    //   }
    // },
    updateBuildNumber: function updateBuildNumber() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var buildNumber;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              buildNumber = version.build;
              _this8.$store.commit("updateBuildNumber", buildNumber);
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    validatePurchaseOnBackend: function validatePurchaseOnBackend(purchaseToken) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              console.log(purchaseToken);
              // const response = await fetch('https://example.com/validate', {
              //   method: 'POST',
              //   body: JSON.stringify({ purchaseToken }),
              // });
              // const data = await response.json();
              // return data.isValid;
              return _context11.abrupt("return", true);
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    getBillingDetails: function getBillingDetails() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var service, detailsSubscription, detailsClothing;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              if (!("getDigitalGoodsService" in window)) {
                _context12.next = 13;
                break;
              }
              _context12.next = 4;
              return window.getDigitalGoodsService("https://play.google.com/billing");
            case 4:
              service = _context12.sent;
              _context12.next = 7;
              return service.getDetails(["aivitar_scubscription"]);
            case 7:
              detailsSubscription = _context12.sent;
              _this9.playBillingDetails.subscription = JSON.stringify(detailsSubscription);
              _context12.next = 11;
              return service.getDetails(["clothing"]);
            case 11:
              detailsClothing = _context12.sent;
              _this9.playBillingDetails.detailsFromButtonClothing = JSON.stringify(detailsClothing);
            case 13:
              _context12.next = 18;
              break;
            case 15:
              _context12.prev = 15;
              _context12.t0 = _context12["catch"](0);
              _this9.playBillingDetails.error = _context12.t0;
              // log(error);
            case 18:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 15]]);
      }))();
    },
    update: function update() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this10.prompt = false;
              // await this.$workbox.messageSW({ type: "SKIP_WAITING" });
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    }
  },
  data: function data() {
    return {
      browser: "",
      notsupportedbrowser: false,
      showRedirectPage: true,
      audioMap: new Map(),
      // messaging,
      originalPosition: {
        x: 10,
        y: 150
      },
      // Set based on your default positioning
      currentPosition: {
        x: 10,
        y: 150
      },
      isDragging: false,
      isEnlarged: false,
      showGoogleSubscriptionPaymentOptions: false,
      showLogin: false,
      showMainApplication: false,
      purchaseResponse: "",
      paymentComplete: "",
      version: version,
      playBillingActive: false,
      showInstallPrompt: false,
      playBillingDetails: {},
      alexaDevelopment: localStorage.getItem("alexaDevelopment") ? true : false,
      currentWalkthroughIndex: 0,
      showWalkthrough: false,
      walkthroughDemo: [{
        label: "Toggle Talk/Listen/Continuous listening modes",
        targetId: "walkthrough-speech-items",
        positionX: "center",
        positionY: "bottom",
        distance: 20
      }, {
        label: "Toggle Talk/Listen/Continuous listening modes",
        targetId: "walkthrough-speech-items",
        positionX: "right",
        positionY: "top",
        distance: 50
      }],
      prompt: false,
      logleft: window.innerWidth - window.innerWidth * 2,
      dmCounter: 0,
      displayMode: "",
      showApplication: false,
      isInstalling: false
    };
  }
});